<template>
  <div class="p-3">
    <b-overlay :show="isLoading">
      <b-row v-if="this.selectedDataset === null">
        <b-col>
          <h5>Datasets</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          :class="{
            'd-none': selectedDataset !== null,
            'd-md-block': selectedDataset !== null,
          }"
          sm="0"
        >
          <b-list-group>
            <b-list-group-item
              class="clickable"
              v-for="item in list"
              :key="item.id"
              @click="loadDataset(item)"
            >
              <b-row>
                <b-col>
                  <span>
                    {{ item.datasetName }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <small class="text-muted">
                    Owner: {{ item.createdBy }}
                  </small>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <small class="text-muted"
                    >Data last updated at
                    {{ item.datasetLastUpdatedDateTime | toLocaleString }}
                  </small>
                </b-col>
              </b-row>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-overlay>

    <b-modal
      v-model="showDataset"
      size="xl"
      hide-footer
      scrollable
      header-class="p-1 pr-2"
      style="height: 100%; width: 100%"
    >
      <b-row v-if="showDataset">
        <b-col>
          <section v-if="filters.length">
            <b-row>
              <b-col>
                <filter-container
                  v-model="filters"
                  :selected-cube-id="selectedDataset.cubeConfigId"
                ></filter-container>
              </b-col>
            </b-row>
          </section>
          <b-card>
            <template #header>
              <b-row>
                <b-col>
                  <div>
                    <small class="text-muted"
                      >Data last updated at
                      {{
                        selectedDataset.datasetLastUpdatedDateTime
                          | toLocaleString
                      }}</small
                    >
                    <b-button
                      class="ml-3"
                      size="sm"
                      variant="outline-primary"
                      @click="refreshData"
                    >
                      <b-icon-arrow-counterclockwise
                        shift-v="-2"
                        font-scale="1.2"
                      />
                      Refresh
                    </b-button>
                    <b-icon-x
                      class="float-right clickable"
                      variant="primary"
                      font-scale="1.8"
                      title="close"
                      @click="selectedDataset = null"
                    />
                    <b-icon-gear-fill
                      v-if="
                        selectedDataset.id !== null &&
                          selectedDataset.owner === currentUser.name
                      "
                      variant="primary"
                      class="clickable float-right mr-1"
                      font-scale="1.2"
                      shift-v="-4"
                      @click="editMode = !editMode"
                      title="toggle edit mode"
                    />
                  </div>
                </b-col>
              </b-row>
            </template>
            <section v-if="editMode">
              <b-row class="mb-3">
                <b-col>
                  <b-form ref="main-form">
                    <b-row class="mb-2">
                      <b-col cols="6" lg="2">
                        <label>Dataset Name</label>
                      </b-col>
                      <b-col cols="6" lg="3">
                        <b-input
                          v-model="selectedDataset.datasetName"
                          size="sm"
                        />
                      </b-col>
                    </b-row>
                    <!--                <b-row>-->
                    <!--                  <b-col cols="3">Is Private?:</b-col>-->
                    <!--                  <b-col>-->
                    <!--                    <span v-if="editMode" @click="editMode = false">-->
                    <!--                      <b-icon-check-square v-if="selectedDataset.isPrivate" />-->
                    <!--                      <b-icon-x-square v-else />-->
                    <!--                    </span>-->
                    <!--                    <b-checkbox-->
                    <!--                      v-else-->
                    <!--                      v-model="selectedDataset.isPrivate"-->
                    <!--                      :value="true"-->
                    <!--                      :unchecked-value="false"-->
                    <!--                    />-->
                    <!--                  </b-col>-->
                    <!--                </b-row>-->
                  </b-form>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button
                    class="ml-2 float-right"
                    size="sm"
                    variant="primary"
                    @click="updateDataset"
                  >
                    <b-icon-pencil shift-v="-2" font-scale="1.2" />
                    Edit
                  </b-button>
                  <b-button
                    class="float-right"
                    size="sm"
                    @click="deleteDataset"
                  >
                    <b-icon-trash shift-v="-2" font-scale="1.2" />
                    Delete
                  </b-button>
                </b-col>
              </b-row>
              <hr />
            </section>

            <b-row>
              <!--            <b-col cols="3">-->
              <!--              <b-list-group>-->
              <!--                <b-list-group-item v-for="(field) in selectedDataset.datasetFields" :key="field.key">-->
              <!--                  {{ field }}-->
              <!--                </b-list-group-item>-->
              <!--              </b-list-group>-->
              <!--            </b-col>-->
              <b-col>
                <data-viewer :items="items" :fields="fields"></data-viewer>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/*global _*/
import application from '@/mixins/application';
import DataViewer from '@/components/datagrabber/DataViewer';
import FilterContainer from '@/components/datasets/FilterContainer';

export default {
  name: 'ManageDataset',
  mixins: [application],
  components: {
    DataViewer,
    FilterContainer,
  },
  mounted() {
    this.getList();
  },
  data() {
    return {
      list: [],
      selectedDataset: null,
      cubeData: {},

      isLoading: false,
      editMode: false,

      showDataset: false,
    };
  },
  computed: {
    items() {
      if (this.selectedDataset) {
        return this.selectedDataset.datasetCachedData;
      } else {
        return [];
      }
    },
    fields() {
      if (this.selectedDataset) {
        return this.selectedDataset.datasetFields;
      } else {
        return [];
      }
    },
    filters: {
      get() {
        if (this.selectedDataset) {
          return this.selectedDataset.datasetQueryParameters.filters;
        } else {
          return [];
        }
      },
      set(filters) {
        if (filters) {
          this.selectedDataset.datasetQueryParameters.filters = filters;
        }
      },
    },
  },
  methods: {
    getList() {
      const vm = this;
      return vm.axios.get('/api/datasets').then(resp => {
        vm.list = _.orderBy(
          resp.data,
          ['datasetLastUpdatedDateTime'],
          ['desc']
        );
      });
    },
    loadDataset(selectedDataset) {
      this.showDataset = false;
      this.editMode = false;
      this.isLoading = true;
      this.axios
        .get('/api/datasets/' + selectedDataset.id)
        .then(resp => {
          const dataset = _.cloneDeep(resp.data);
          if (dataset.id !== selectedDataset.id) {
            return; //process data if user haven't change the selection
          }

          dataset.datasetCachedData = JSON.parse(dataset.datasetCachedData);
          dataset.datasetFields = JSON.parse(dataset.datasetFields);
          dataset.datasetQueryParameters = JSON.parse(
            dataset.datasetQueryParameters
          );
          this.selectedDataset = dataset;
          this.showDataset = true;

          const cubeConfigId = dataset.cubeConfigId;
          this.axios
            .get('/api/dataGrabber/' + cubeConfigId + '/configuration')
            .then(resp => {
              if (dataset.id !== selectedDataset.id) {
                return; //process data if user haven't change the selection
              }
              this.isLoading = false;

              const cubeData = resp.data;
              this.cubeData = cubeData;
              let filters = _.cloneDeep(
                this.selectedDataset.datasetQueryParameters.filters
              );
              _.forEach(filters, filter => {
                filter.hierarchies = _.filter(cubeData.levels, {
                  hierarchyId: filter.level.hierarchyId,
                });
                filter.isHierarchy = filter.hierarchies.length > 1;
              });
              this.selectedDataset.datasetQueryParameters.filters = filters;
            });
        })
        .catch(() => {
          this.PromptWarning(
            'Failed',
            'Failed to load the data. Please try again.'
          );
        });
    },
    updateDataset(event) {
      const form = this.$refs['main-form'];
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      const vm = this;
      const dataset = _.cloneDeep(vm.selectedDataset);
      dataset.datasetFields = JSON.stringify(dataset.datasetFields);
      dataset.datasetCachedData = ''; //the cached data will be ignored anyway
      this.$bvModal
        .msgBoxConfirm('Proceed to edit the dataset?', { centered: true })
        .then(confirm => {
          if (confirm) {
            vm.axios
              .put('/api/datasets/' + dataset.id, dataset)
              .then(() => {
                vm.getList();
                vm.PromptSuccess(
                  'Success',
                  'Dataset had been edited successfully.'
                );
              })
              .catch(() => {
                vm.PromptWarning(
                  'Failed',
                  'Failed to edit dataset. Please try again.'
                );
              });
          }
        });
    },
    deleteDataset() {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete the dataset?', { centered: true })
        .then(confirm => {
          if (confirm) {
            const vm = this;
            const dataset = _.cloneDeep(vm.selectedDataset);
            vm.axios
              .delete('/api/datasets/' + dataset.id)
              .then(() => {
                vm.getList().then(() => {
                  vm.selectedDataset = null;
                });
                vm.PromptSuccess(
                  'Success',
                  'Dataset had been deleted successfully.'
                );
              })
              .catch(() => {
                vm.PromptWarning(
                  'Failed',
                  'Failed to delete dataset. Please try again.'
                );
              });
          }
        });
    },
    refreshData() {
      this.$bvModal
        .msgBoxConfirm('Proceed to refresh the data?', { centered: true })
        .then(confirm => {
          if (confirm) {
            const vm = this;
            const dataset = _.cloneDeep(vm.selectedDataset);
            const queryParameter = dataset.datasetQueryParameters;
            vm.axios
              .post(
                '/api/datasets/' +
                  dataset.id +
                  '/grabdata/' +
                  dataset.cubeConfigId,
                queryParameter
              )
              .then(resp => {
                if (resp.data) {
                  vm.PromptSuccess('Success', 'Data had been refreshed.');
                  vm.loadDataset({ id: dataset.id });
                } else {
                  vm.PromptWarning(
                    'Failed',
                    'Failed to refresh data. Please try again later.'
                  );
                }
              })
              .catch(() => {
                vm.PromptWarning(
                  'Failed',
                  'Failed to refresh data. Please try again later.'
                );
              });
          }
        });
    },
  },
  filters: {
    toLocaleString: function(value) {
      if (!value) return '';
      value = value.toString();
      if (value.slice(-1).toLowerCase() !== 'z') value = value + 'Z';
      return new Date(value).toLocaleString();
    },
  },
};
</script>